import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faFacebookF,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="jpft">
      {/* nền – tia sáng & sóng */}
      {/* nền – tia sáng & sóng động */}
      <div className="jpft__bg" aria-hidden>
        {/* Lớp sóng sau (trong, chậm) */}
        <div className="jpft__waves jpft__waves--back">
          <svg
            className="piece"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,80 C120,20 280,10 420,50 C560,90 700,100 860,60 C1040,15 1200,25 1440,80 L1440,120 L0,120 Z"
              fill="url(#wgrad-back)"
            />
            <defs>
              <linearGradient id="wgrad-back" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#ffffff" stopOpacity=".85" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="1" />
              </linearGradient>
            </defs>
          </svg>
          {/* lặp lại 2 lần để cuộn vô tận */}
          <svg
            className="piece"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,80 C120,20 280,10 420,50 C560,90 700,100 860,60 C1040,15 1200,25 1440,80 L1440,120 L0,120 Z"
              fill="url(#wgrad-back)"
            />
          </svg>
        </div>

        {/* Lớp sóng trước (đậm hơn, nhanh hơn chút) */}
        <div className="jpft__waves jpft__waves--front">
          <svg
            className="piece"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,90 C160,40 300,30 450,60 C620,95 760,100 900,70 C1080,25 1260,40 1440,90 L1440,120 L0,120 Z"
              fill="url(#wgrad-front)"
            />
            <defs>
              <linearGradient id="wgrad-front" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#ffffff" stopOpacity=".98" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="1" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            className="piece"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,90 C160,40 300,30 450,60 C620,95 760,100 900,70 C1080,25 1260,40 1440,90 L1440,120 L0,120 Z"
              fill="url(#wgrad-front)"
            />
          </svg>
        </div>
      </div>

      <div className="jpft__inner">
        {/* brand + mô tả + social */}
        <section className="jpft__col">
          <div className="jpft__brand">
            <img
              src="/images/logo1.png"
              alt="rumi logo"
              className="rumi-logo"
            />

            <span className="jpft__tag">ru con trưởng thành</span>
          </div>
          <p className="jpft__desc">CÔNG TY CỔ PHẦN THƯƠNG MẠI DỊCH VỤ WMA</p>
          <p className="jpft__desc">
            Đ/c: Số 24, lô TT02, KĐT Hải Đăng, Phường Từ Liêm, Hà Nội, Việt Nam
          </p>
        </section>

        {/* menu */}
        <nav className="jpft__col">
          <h4 className="jpft__hd">Menu</h4>
          <ul className="jpft__list">
            <li>
              <Link to="/">Trang chủ</Link>
            </li>
            <li>
              <Link to="/products">Sản phẩm</Link>
            </li>
            <li>
              <Link to="/news">Tin tức</Link>
            </li>

            <li>
              <Link to="/about">Giới thiệu</Link>
            </li>
          </ul>
        </nav>

        {/* hỗ trợ */}
        <div className="jpft__col">
          <h4 className="jpft__hd">Chính sách</h4>
          <ul className="jpft__list">
            <li>
              <a href="#">Hướng dẫn mua hàng</a>
            </li>
            <li>
              <a href="#">Chính sách đổi trả</a>
            </li>
            <li>
              <a href="#">Bảo mật &amp; thanh toán</a>
            </li>
            <li>
              <a href="#">Câu hỏi thường gặp</a>
            </li>
          </ul>
        </div>

        {/* liên hệ + newsletter */}
        <div className="jpft__col">
          <h4 className="jpft__hd">Liên hệ</h4>
          <ul className="jpft__list">
            <li>Rumi Việt Nam</li>
            <li>Email: tabimrumi@gmail.com</li>
            <li>Phone: (+84) 981 623 690</li>
          </ul>

          <div className="jpft__social">
            <a
              href="https://www.facebook.com/tabimrumi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                className="footer_icon text-primary"
                icon={faFacebookF}
                mask={faCircle}
                transform="shrink-7"
              />
            </a>
            <a
              href="https://www.youtube.com/@tabimrumi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                className="footer_icon text-danger"
                icon={faYoutube}
              />
            </a>
            <a
              href="https://www.tiktok.com/@tabimrumi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                className="footer_icon text-dark"
                icon={faTiktok}
              />
            </a>
          </div>
        </div>
      </div>

      <div className="jpft__bottom">
        <span>© {new Date().getFullYear()} Rumi Inc. All rights reserved.</span>
      </div>
    </footer>
  );
}
